<template>
  <div>Mensagens:
    <v-list>
      <template v-for="(m) in mensagens">
        <div :key="m.bsgIntCod">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{m.bsgStrPergunta}}</v-list-item-title>
              <v-list-item-subtitle class="pl-4" v-if="m.bsgStrResposta">{{m.bsgStrResposta}} - {{m.bsgDtmResposta | formatDateTime}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </div>
      </template>
    </v-list>
  </div>
</template>

<script>

export default {
  data: () => ({
  }),
  methods: {

  },
  props: ['mensagens'],
}
</script>

<style>
.v-list-item__title, .v-list-item__subtitle {
  white-space: normal !important;
}
</style>